export * from "@trpc/react-query/shared";

export const ENDPOINTS = [
  "loggedInViewerRouter",
  "admin",
  "apiKeys",
  "appRoutingForms",
  "apps",
  "auth",
  "availability",
  "appBasecamp3",
  "bookings",
  "clients",
  "calendars",
  "calVideo",
  "credentials",
  "deploymentSetup",
  "dsync",
  "eventTypes",
  "eventTypesHeavy",
  "features",
  "feedback",
  "holidays",
  "featureOptIn",
  "i18n",
  "insights",
  "me",
  "ooo",
  "payments",
  "public",
  "timezones",
  "saml",
  "slots",
  "teams",
  "organizations",
  "travelSchedules",
  "users",
  "viewer",
  "webhook",
  "workflows",
  "googleWorkspace",
  "oAuth",
  "attributes",
  "delegationCredential",
  "routingForms",
  "credits",
  "filterSegments",
  "aiVoiceAgent",
  "phoneNumber",
  "pbac",
  "attributeSync",
  "gowa",
] as const;
